import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import StatusIconCDS from '@sharedCR/coreDesignSystem/StatusIconCDS';
import PropTypes from 'prop-types';

import { StatusEnum } from 'constants/status';

import { getWrapperStyles, messageStyles } from './InlineNotice.styles';

// Inline banner used for the over-budget / over-remaining / approval-blocked notices. AlertCDS is a
// snackbar/toast primitive (fixed-position), so it can't sit inline in a page block — this composes
// the same CDS StatusIconCDS + type ramp against the theme's soft-tone surfaces instead.
const InlineNotice = ({ variant = StatusEnum.INFO, children, dataTestId }) => (
  <Box data-testid={dataTestId} sx={getWrapperStyles(variant)}>
    <StatusIconCDS type={variant} />
    <Typography component="div" sx={messageStyles} variant="regular14">
      {children}
    </Typography>
  </Box>
);

InlineNotice.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(Object.values(StatusEnum)),
  dataTestId: PropTypes.string,
};

export default memo(InlineNotice);
